<template>
  <div>
    <v-card
      v-for="subject in subjects"
      :key="subject.id"
      class="mb-8 pb-8 px-8"
    >
      <v-card-title>{{ subject.name }}

        <!-- Nút tải lên Excel -->
        <v-spacer></v-spacer>
        <v-btn outlined color="success" @click="$refs['fileInput-' + subject.id][0].click()" class="mr-6">
          <v-icon left>mdi-file-excel</v-icon> Tải lên đáp án
        </v-btn>
        <v-btn outlined dark color="success" href="/DapAnMauMonToan.xlsx" target="_blank">
          <v-icon left>mdi-download</v-icon> Mẫu Đáp án
        </v-btn>
        <input
          type="file"
          :ref="'fileInput-' + subject.id"
          class="d-none"
          accept=".xlsx,.xls"
          @change="handleFileUpload($event, subject)"
        />


      </v-card-title>
      <div class="table-wrapper">
        <v-simple-table dense class="variant-table">
          <thead>
            <!-- Dòng 1 -->
            <tr>
              <th rowspan="3" class="text-center">Mã đề</th>
              <th colspan="40" class="text-center">Phần I</th>
              <th colspan="32" class="text-center">Phần II</th>
              <th colspan="6" class="text-center">Phần III</th>
            </tr>

            <!-- Dòng 2 -->
            <tr>
              <th v-for="i in 40" :key="'p1-q'+i">Câu {{ i }}</th>
              <th v-for="q in part2Labels" :key="q">{{ q }}</th>
              <th v-for="i in 6" :key="'p3-q'+i">Câu {{ i }}</th>
            </tr>

            <!-- Dòng 3: điểm số -->
            <tr v-if="subject.examVariants.length">
              <!-- Part1 -->
              <td v-for="i in 40" :key="'s1-'+i">
                <input
                  :value="getScoreValue(subject,'part1',i-1)"
                  style="width: 70px; text-align:center"
                  @input="updateScore(subject,'part1',i-1,$event.target.value)"
                  @blur="saveScores(subject,'part1',i-1,getScoreValue(subject,'part1',i-1))"
                />
              </td>

              <!-- Part2 -->
              <td v-for="i in 32" :key="'s2-'+i">
                <input
                  :value="getScoreValue(subject,'part2',i-1)"
                  style="width: 70px; text-align:center"
                  @input="updateScore(subject,'part2',i-1,$event.target.value)"
                  @blur="saveScores(subject,'part2',i-1,getScoreValue(subject,'part2',i-1))"
                />
              </td>

              <!-- Part3 -->
              <td v-for="i in 6" :key="'s3-'+i">
                <input
                  :value="getScoreValue(subject,'part3',i-1)"
                  style="width: 70px; text-align:center"
                  @input="updateScore(subject,'part3',i-1,$event.target.value)"
                  @blur="saveScores(subject,'part3',i-1,getScoreValue(subject,'part3',i-1))"
                />
              </td>
            </tr>
          </thead>

          <tbody>
            <!-- Dữ liệu examVariants -->
            <tr v-for="variant in subject.examVariants" :key="variant.id">
              <!-- Cột Mã đề --> 
              <td 
              style="display: flex;">
                <v-btn
                  small
                  icon
                  color="red"
                  @click="deleteVariant(variant.id)"
                  title="Xoá mã đề"
                >
                  <v-icon small>mdi-delete</v-icon>
                </v-btn>
                <input
                  v-model="variant.code"
                  style="width: 100px; text-align:center"
                  @blur="saveVariant(variant, 'code', null, variant.code)"
                />
              </td>
              <!-- Phần I -->
              <td v-for="(ans, i) in 40" :key="'v1-'+variant.id+'-'+i">
                <v-select
                  :items="['A','B','C','D']"
                  v-model="variant.part1[i]"
                  dense
                  hide-details
                  append-icon="" 
                  style="width: 70px"
                  @change="saveVariant(variant,'part1',i,variant.part1[i])"
                />
              </td>
              <!-- Phần II -->
              <td v-for="(ans, i) in 32" :key="'v2-'+variant.id+'-'+i">
                <v-select
                  :items="['Đ','S']"
                  v-model="variant.part2[i]"
                  dense
                  hide-details
                  append-icon="" 
                  style="width: 70px"
                  @change="saveVariant(variant,'part2',i,variant.part2[i])"
                />
              </td>

              <!-- Phần III -->
              <td v-for="i in 6" :key="'v3-'+variant.id+'-'+i">
                <input
                  :value="getPart3Value(variant, i-1)"
                  style="width: 70px; text-align:center"
                @input="setPart3Value(variant, i-1, $event.target.value)"
                @blur="saveVariant(variant,'part3',i-1,getPart3Value(variant, i-1))"
                @keyup.enter="saveVariant(variant,'part3',i-1,getPart3Value(variant, i-1))"
                />
            </td>
            </tr>
          </tbody>
        </v-simple-table>
      </div>
    </v-card>
  </div>
</template>

<script>
import { mapActions } from "vuex"
import alert from "@/plugins/alert"
import * as XLSX from "xlsx"

export default {
  props: { query: { type: Object, default: () => ({}) } },
  data() {
    return {
      items: [],
      editState: { id: null, part: null, index: null },
      editValue: "",
      part2Labels: [
        "1a","1b","1c","1d",
        "2a","2b","2c","2d",
        "3a","3b","3c","3d",
        "4a","4b","4c","4d",
        "5a","5b","5c","5d",
        "6a","6b","6c","6d",
        "7a","7b","7c","7d",
        "8a","8b","8c","8d"
      ]
    }
  },
  computed: {
    subjects() {
      const groups = {}

      this.items.forEach(ev => {
        if (Array.isArray(ev.subjects)) {
          ev.subjects.forEach(seV => {
            if (seV && seV.id) {
              if (!groups[seV.id]) {
                groups[seV.id] = {
                  id: seV.id,
                  name: seV.name,
                  examVariants: []
                }
              }
              if (Array.isArray(seV.examVariants)) {
                groups[seV.id].examVariants.push(...seV.examVariants)
              }
            }
          })
        }
      })

      return Object.values(groups)
    }
  },
  watch: {
    query: {
      handler() { this.loadData() },
      deep: true,
      immediate: true
    }
  },
  methods: {
    ...mapActions("examVariant", ["fetchExamVariants", "updateExamVariant", "createExamVariant", "removeExamVariants"]),

    async loadData() {
      try {
        this.$loading.active = true
        console.log(this.query)
        const data = await this.fetchExamVariants(this.query) || []
        this.items = Array.isArray(data) ? JSON.parse(JSON.stringify(data)) : []
        console.log("Fetched examVariants:", JSON.parse(JSON.stringify(this.items)))
      } catch (e) {
        console.error(e)
        alert.error("Không thể tải danh sách mã đề")
      } finally {
        this.$loading.active = false
      }
    },

    getScores(subject, part) {
      if (!subject.examVariants.length) return []
      const first = subject.examVariants[0].scores
      if (!first) return []
      if (part === "part1") return first.part1 ? first.part1.map(v => ({ value: v })) : []
      if (part === "part2") return first.part2 || []
      if (part === "part3") {
        const math = (first.part3 && first.part3.math) || []
        const others = (first.part3 && first.part3.others) || []
        return math.concat(others)
      }
      return []
    },
    startEdit(id, part, index, value) {
      this.editState = { id, part, index }
      this.editValue = value
    },
    isEditing(id, part, index) {
      return (
        this.editState.id === id &&
        this.editState.part === part &&
        this.editState.index === index
      )
    },

    async saveScores(subject, part, index, value) {
      const firstVariant = subject.examVariants[0]
      if (!firstVariant) return

      if (part === "part1") firstVariant.scores.part1[index] = Number(value)
      if (part === "part2") firstVariant.scores.part2[index].point = Number(value)
      if (part === "part3") {
        if (index < 6) firstVariant.scores.part3.math[index] = Number(value)
        else firstVariant.scores.part3.others[index - 6] = Number(value)
      }
      await this.updateExamVariant({ id: firstVariant.id, scores: firstVariant.scores })
      this.editState = { id: null, part: null, index: null }
    },

    async saveVariant(variant, part, index, value) {
      if (part === "part1" && !["A","B","C","D","",null].includes(value)) {
        alert("Chỉ nhập A/B/C/D")
        return
      }
      if (part === "part2" && !["Đ","S","",null].includes(value)) {
        alert("Chỉ nhập Đ hoặc S")
        return
      }
      if (part === "part3" && value !== "" && isNaN(Number(value))) {
        alert("Chỉ nhập số")
        return
      }

      if (part === "part1") variant.part1[index] = value
      if (part === "part2") variant.part2[index] = value
      if (part === "part3") variant.part3.math[index] = Number(value)

      await this.updateExamVariant({ id: variant.id, ...variant })
      this.editState = { id: null, part: null, index: null }
    },
    getPart3Value(variant, index) {
      if (!variant.part3) {
        this.$set(variant, "part3", { math: Array(6).fill(null), others: Array(6).fill(null) })
      }
      if (!Array.isArray(variant.part3.math)) {
        this.$set(variant.part3, "math", Array(6).fill(null))
      }
      return variant.part3.math[index]
    },
    setPart3Value(variant, index, value) {
      if (!variant.part3) {
        this.$set(variant, "part3", { math: Array(6).fill(null), others: Array(6).fill(null) })
      }
      if (!Array.isArray(variant.part3.math)) {
        this.$set(variant.part3, "math", Array(6).fill(null))
      }
      this.$set(variant.part3.math, index, value === "" ? null : Number(value))
    },
    getScoreValue(subject, part, index) {
      const first = subject.examVariants[0]
      if (!first.scores) {
        this.$set(first, "scores", { part1: [], part2: [], part3: { math: [], others: [] } })
      }

      if (part === "part1") {
        if (!Array.isArray(first.scores.part1)) this.$set(first.scores, "part1", [])
        return first.scores.part1[index] || ""
      }

      if (part === "part2") {
        if (!Array.isArray(first.scores.part2)) this.$set(first.scores, "part2", [])
        if (!first.scores.part2[index]) this.$set(first.scores.part2, index, { q: "", point: "" })
        return first.scores.part2[index].point || ""
      }

      if (part === "part3") {
        if (!first.scores.part3) this.$set(first.scores, "part3", { math: [], others: [] })
        if (!Array.isArray(first.scores.part3.math)) this.$set(first.scores.part3, "math", [])
        if (!Array.isArray(first.scores.part3.others)) this.$set(first.scores.part3, "others", [])

        if (index < 6) return first.scores.part3.math[index] || ""
        return first.scores.part3.others[index - 6] || ""
      }
      return ""
    },

    updateScore(subject, part, index, value) {
      const first = subject.examVariants[0]
      if (!first.scores) return

      if (part === "part1") this.$set(first.scores.part1, index, value)
      if (part === "part2") this.$set(first.scores.part2[index], "point", value)
      if (part === "part3") {
        if (index < 6) this.$set(first.scores.part3.math, index, value)
        else this.$set(first.scores.part3.others, index - 6, value)
      }
    },
    triggerFileInput(subject) {
      const refName = "fileInput-" + subject.id
      const input = this.$refs[refName]
      if (input) input.click()
    },
    async handleFileUpload(e, subject) {
      const file = e.target.files[0]
      if (!file) return

      try {
        const data = await file.arrayBuffer()
        const workbook = XLSX.read(data, { type: "array" })
        const firstSheet = workbook.Sheets[workbook.SheetNames[0]]
        const rows = XLSX.utils.sheet_to_json(firstSheet, { header: 1 })

        console.log("Excel raw rows:", rows)

        // ⚡ Parse Excel rows
        const parsedVariants = rows.slice(3).map(r => ({
          code: r[0],                  // cột A = mã đề
          part1: r.slice(1, 41),       // 40 cột
          part2: r.slice(41, 73),      // 32 cột
          part3: { math: r.slice(73, 79).map(v => v || null) } // 6 cột
          // nếu cần thêm scores từ file thì parse tiếp ở đây
        }))

        for (const variant of parsedVariants) {
          if (!variant.code) continue // bỏ qua dòng trống

          // Tìm trong subject.examVariants
          const existing = subject.examVariants.find(ev => ev.code === variant.code)

          // Chuẩn bị scores mặc định nếu không có
          const defaultScores = {
            part1: Array.from({ length: 40 }, () => 0.25),
            part2: this.part2Labels.map(q => ({ q, point: 1 })), // giả sử 1 điểm
            part3: { math: Array(6).fill(0.5), others: Array(6).fill(0.25) }
          }

          if (existing) {
            console.log("Update variant:", variant.code)
            await this.updateExamVariant({
              id: existing.id,
              ...existing,
              part1: variant.part1,
              part2: variant.part2,
              part3: variant.part3,
              scores: existing.scores || defaultScores
            })
          } else {
            console.log("Create variant:", variant.code)
            await this.createExamVariant({
              exam: this.query ? this.query.exam : null,
              subjectGroup: this.query ? this.query.subjectGroup : null,
              code: variant.code,
              part1: variant.part1,
              part2: variant.part2,
              part3: variant.part3,
              scores: defaultScores,
              subjects: [subject.id]
            })
          }
        }

        alert.success("Upload đáp án thành công!")
        this.loadData()

      } catch (err) {
        console.error(err)
        alert.error("Không thể đọc file Excel")
      } finally {
        e.target.value = null
      }
    },
    async deleteVariant(id) {
      try {
        await this.removeExamVariants(id)
        this.loadData()
      } catch (e) {
        console.error(e)
        alert.error("Không xoá được mã đề")
      }
    },
  }
}
</script>
<style scoped>
.variant-table th,
.variant-table td {
  border: 1px solid;
  padding: 2px;
  text-align: center;
}
.v-data-table__wrapper {
  overflow-x: auto !important;        /* cho phép cuộn ngang */
  -ms-overflow-style: none !important; /* ẩn scroll IE/Edge */
  scrollbar-width: none !important;    /* ẩn scroll Firefox */
}

.v-data-table__wrapper::-webkit-scrollbar {
  display: none !important;            /* ẩn scroll Chrome/Safari */
}
</style>
